@if (planwerte) {
  <div>
    <table
      mat-table [dataSource]="planwerte"
      class="planwerte-table"
      matSort
      (matSortChange)="_sortChange($event)"
      [matSortDirection]="sortDirection"
      [matSortActive]="sortActive"
      >
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let planwert; columns: columnsToDisplay"
        class="normal-value-row"
        [routerLink]="routingService.planwertPath()"
        [queryParams]="{erzeugungsanlage: planwert.erzeugungsanlage.dokumentenId}"
        [queryParamsHandling]="'merge'"
      ></tr>
      <ng-container matColumnDef="erzeugungsanlage.dokumentenId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="dokumenten-id">Dokumenten ID</th>
        <td mat-cell *matCellDef="let planwert;" data-qa="dokumenten-id">
          {{planwert.erzeugungsanlage.dokumentenId}}
        </td>
      </ng-container>
      <ng-container matColumnDef="erzeugungsanlage.resourceIds.technischeResourceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="tr-id">TR-ID</th>
        <td mat-cell *matCellDef="let planwert;" data-qa="tr-id">
          {{planwert.erzeugungsanlage.resourceIds?.technischeResourceId}}
        </td>
      </ng-container>
      <ng-container matColumnDef="erzeugungsanlage.bezVnbIntern">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="bezeichnung-vnb-intern">
          Bezeichnung VNB intern
        </th>
        <td mat-cell *matCellDef="let planwert;" data-qa="bezeichnung-vnb-intern">
          {{planwert.erzeugungsanlage.bezVnbIntern}}
        </td>
      </ng-container>
      <ng-container matColumnDef="netzverknuepfungspunkt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="netzverknuepfungspunkt">
          Netzverknüpfungspunkt
        </th>
        <td mat-cell *matCellDef="let planwert;" data-qa="netzverknuepfungspunkt">
          {{planwert.netzverknuepfungspunkt}}
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef data-qa="type">Datenfeld</th>
        <td mat-cell *matCellDef="let planwert;" data-qa="type">
          {{planwert.type | planwertType}}
        </td>
      </ng-container>
      <ng-container matColumnDef="originalValue">
        <th mat-header-cell *matHeaderCellDef data-qa="original-value">IST-Wert</th>
        <td mat-cell *matCellDef="let planwert;" data-qa="original-value">
          {{getErzeugungsanlagenFieldValueByPlanwerType(planwert)}}
        </td>
      </ng-container>
      <ng-container matColumnDef="plannedValue">
        <th mat-header-cell *matHeaderCellDef data-qa="planned-value">SOLL-Wert</th>
        <td mat-cell *matCellDef="let planwert;" data-qa="planned-value">
          {{planwert.plannedValue}}
        </td>
      </ng-container>
      <ng-container matColumnDef="dataTransferDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="data-transfer-date">Planwert-Datum</th>
        <td mat-cell *matCellDef="let planwert;" data-qa="data-transfer-date">
          {{planwert.dataTransferDate | date: 'dd.MM.yyyy'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header  data-qa="status">Status</th>
        <td mat-cell *matCellDef="let planwert;"
            class="planwert-status"
            data-qa="status"
            [class]="planwertStatusToClass(planwert.status)"
            [matTooltip]="planwert.errorMessage"
            aria-label="{{ planwert.status | planwertStatus }} {{ planwert.errorMessage }}"
        >
          {{ planwert.status | planwertStatus }}
        </td>
      </ng-container>
    </table>
  </div>
}
